var _circle, _circle2, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgAddressConfirmationStatus = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 108,
    height: 37,
    viewBox: "0 0 108 37",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 17.9175,
    cy: 18.3379,
    r: 17.8542,
    fill: "#FD9435"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 89.4433,
    cy: 18.3379,
    r: 17.8542,
    fill: "black",
    fillOpacity: 0.25
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M69.5888 18.6238C70.1411 18.6238 70.5888 18.1761 70.5888 17.6238C70.5888 17.0715 70.1411 16.6238 69.5888 16.6238V18.6238ZM33.7717 18.6238H69.5888V16.6238H33.7717V18.6238Z",
    fill: "#FD9435"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4744 12.5403V10.8803H19.2344V25.3403H17.3944V12.5403H15.4744Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M84.7113 23.8803C86.4047 22.5203 87.7313 21.407 88.6913 20.5403C89.6513 19.6603 90.458 18.747 91.1113 17.8003C91.778 16.8403 92.1113 15.9003 92.1113 14.9803C92.1113 14.1137 91.898 13.4337 91.4713 12.9403C91.058 12.4337 90.3847 12.1803 89.4513 12.1803C88.5447 12.1803 87.838 12.467 87.3313 13.0403C86.838 13.6003 86.5713 14.3537 86.5313 15.3003H84.7713C84.8247 13.807 85.278 12.6537 86.1313 11.8403C86.9847 11.027 88.0847 10.6203 89.4313 10.6203C90.8047 10.6203 91.8913 11.0003 92.6913 11.7603C93.5047 12.5203 93.9113 13.567 93.9113 14.9003C93.9113 16.007 93.578 17.087 92.9113 18.1403C92.258 19.1803 91.5113 20.1003 90.6713 20.9003C89.8313 21.687 88.758 22.607 87.4513 23.6603H94.3313V25.1803H84.7113V23.8803Z",
    fill: "#A2A2A2"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgAddressConfirmationStatus, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/addressConfirmationStatus.5f911051.svg";
export { ForwardRef as ReactComponent };